export default __webpack_public_path__ + "static/media/Wheel Blade.0a585e97.jpg";